import React from "react";
import get from "lodash/get";
import { object, bool, string, number, array } from "prop-types";

import Contributor from "../../atoms/Contributor";
import ContributorImage from "../../atoms/ContributorImage";
import { getAuthorName } from "../../utils/utils";

import "./authorDetails.m.css";

const AuthorDetails = ({
  story = {},
  authors = [],
  authorDisplayName = "",
  withAvatar = true,
  contributorType = 4,
  role = "",
  authorDetailsType = "",
  lang = "en",
  location = true,
}) => {
  const authorName = getAuthorName(story);
  const authorLocation = get(story, ["metadata", "author-location"], "");
  const slug = authors[0] ? `/author/${authors[0].slug}` : "";
  const authorBio = get(authors, ["0", "bio"], "");
  let showAuthorImage = "no";
  let showAuthorBio = "no";
  if (get(authors[0], "metadata['Public Author']")) {
    const publicAuthorStatus = get(authors[0], "metadata['Public Author']").split(",");
    showAuthorImage = publicAuthorStatus[0] ? publicAuthorStatus[0].toLowerCase() : "no";
    showAuthorBio = publicAuthorStatus[1] ? publicAuthorStatus[1].toLowerCase().trim() : "no";
  }
  return (
    <div styleName="base">
      <div
        className={`author-details ${
          showAuthorImage === "no" || authors.length !== 1 ? "no-author-image" : "author-image"
        }`}
        styleName={authorDetailsType}
      >
        {showAuthorImage === "yes" && authors.length === 1 && withAvatar && !authorDisplayName && (
          <ContributorImage authorObj={authors[0]} slug={slug} />
        )}
        {withAvatar && authorDisplayName && (
          <ContributorImage authorDisplayName={authorDisplayName} authorObj={authors[0]} slug={slug} />
        )}
        <div className="author-name-location-wrapper">
          <div styleName="authors-list" className="print-authors-list">
            {!authorDisplayName && authors.length > 0 ? (
              authors.map((item, index) => (
                <Contributor
                  key={index}
                  name={item.name}
                  role={role}
                  contributorType={contributorType}
                  slug={`/author/${item.slug}`}
                  authorObj={item}
                />
              ))
            ) : (
              <Contributor
                name={authorName}
                role={role}
                contributorType={contributorType}
                slug={slug}
                authorObj={authors[0] || {}}
                authorDisplayName={authorDisplayName}
              />
            )}
          </div>
          {location && authorLocation && (
            <span className="author-location" styleName={`author-location ${lang}-author-location`}>
              {authorLocation}
            </span>
          )}
          {authors.length === 1 && showAuthorBio === "bio" && authorBio && (
            <span className="author-bio" styleName="author-bio">
              {authorBio}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

AuthorDetails.propTypes = {
  story: object,
  authors: array,
  withAvatar: bool,
  contributorType: number,
  role: string,
  authorDisplayName: string,
  authorDetailsType: string,
  lang: string,
  location: bool,
};

export default AuthorDetails;
